import React, { useState } from "react";
import { useForm, useStep } from "react-hooks-helper";

import BvnForm from "./bvnForm";
import BasicInformation from "./basicInformation";
import UpdateInformation from "./updateInformation";
import Success from "./success";
import SuccessUpdate from "./successUpdate";
import Doc from "./doc";
import IdentitiValidation from "../components/Validation/IdentitiValidation";
import DocsUpload from "./Doc/DocsUpload";

const steps = [
  { id: "bvn" },
  { id: "basicInfo" },
  { id: "identityValidation" },
  { id: "docs" },

  { id: "success" },
  // { id: "updateInfo" },
  { id: "successUpdate" },
];

const defaultData = {
  bvn: "",
  title: "",
  accountType: "",
  firstName: "",
  middleName: "",
  lastName: "",
  DOB: "",
  religion: "",
  gender: "",
  email: "",

  phoneNumber: "",
  stateOfOrigin: "",
  LGA: "",
  address: "",
  internationalPassport: "",
  passportPhoto: "",
  signature: "",
  utilityBill: "",
  customerId: "",
};

const MultiStepForm = ({ loading }) => {
  const [formData, setForm] = useForm(defaultData);
  const { step, navigation } = useStep({ initialStep: 0, steps });
  const { id } = step;
  const [globalState, setGlobalState] = useState({})
  const props = { formData, setForm, navigation, globalState, setGlobalState };

  switch (id) {
    case "bvn":
      return <BvnForm {...props} />;
    case "basicInfo":
      return <BasicInformation loading={loading} {...props} />;
    case "identityValidation":
      return <IdentitiValidation {...props} loading={loading}/>;
    case "docs":
      return <DocsUpload {...props} loading={loading}/>;
    case "success":
      return <Success {...props} />;
    // case "updateInfo":
    //   return <UpdateInformation loading={loading} {...props} />;
    case "successUpdate":
      return <SuccessUpdate {...props} />;
    default:
      return null;
  }
};
export default MultiStepForm;
